"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _Form = require("./Form");

var _validation = require("./validation");

var Field =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Field, _Component);

  function Field() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      dirty: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onChange", function (fieldValue) {
      _this.props.name && _this.props.valueChanged(_this.props.name, fieldValue);

      if (_this.props.onChange) {
        _this.props.onChange(fieldValue);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "validate", function (fieldValue) {
      var _this$props = _this.props,
          validation = _this$props.validation,
          required = _this$props.required,
          type = _this$props.type,
          values = _this$props.values;
      var errorMessage = '';
      var newValidation = validation;

      if (!newValidation) {
        newValidation = [];
      } else if (!Array.isArray(newValidation)) {
        newValidation = [newValidation];
      }

      if (required) {
        newValidation = [_validation.REQUIRED].concat(newValidation);
      }

      if (type === 'email') {
        newValidation = [_validation.EMAIL].concat(newValidation);
      }

      errorMessage = newValidation.map(function (fun) {
        return fun({
          value: fieldValue,
          values: values,
          name: _this.props.label || _this.props.name,
          errorMessages: _this.props.errorMessages
        });
      }).filter(function (m) {
        return m;
      }).join(' ');
      return errorMessage;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setDirty", function () {
      _this.setState({
        dirty: true
      });
    });
    return _this;
  }

  var _proto = Field.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.name && this.props.addField({
      name: this.props.name,
      value: this.props.value || this.props.defaultValue,
      validate: this.validate
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.onChange(this.props.value);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.removeField(this.props.name);
  };

  _proto.shouldNotRender = function shouldNotRender() {
    var _this2 = this;

    var renderIfValid = this.props.renderIfValid;

    if (renderIfValid) {
      var fields = Array.isArray(renderIfValid) ? renderIfValid : [renderIfValid];
      return fields.filter(function (field) {
        return _this2.props.errors[field];
      }).length;
    }

    return false;
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        addField = _this$props2.addField,
        removeField = _this$props2.removeField,
        errorMessages = _this$props2.errorMessages,
        valueChanged = _this$props2.valueChanged,
        renderIfValid = _this$props2.renderIfValid,
        render = _this$props2.render,
        other = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["addField", "removeField", "errorMessages", "valueChanged", "renderIfValid", "render"]);

    if (this.shouldNotRender()) {
      return null;
    }

    var props = (0, _objectSpread2.default)({}, other, {
      onChange: this.onChange,
      setDirty: this.setDirty
    }, this.state, {
      fieldValue: this.props.values[this.props.name],
      errorMessage: this.props.errors[this.props.name] //$FlowFixMe

    });
    return render(props);
  };

  return Field;
}(_react.Component);

(0, _defineProperty2.default)(Field, "defaultProps", {
  errorMessages: {
    invalidEmail: 'Please provide a valid e-mail address.',
    requiredField: '$label is required.'
  }
});

var _default = function _default(Component) {
  return function (props) {
    var FinalComponent = _react.default.createElement(_Form.Consumer, null, function (value) {
      return _react.default.createElement(Field, (0, _extends2.default)({}, props, value, {
        render: function render(fieldProps) {
          return _react.default.createElement(Component, fieldProps);
        }
      }));
    });

    return (0, _hoistNonReactStatics.default)(FinalComponent, Component);
  };
};

exports.default = _default;